export default __webpack_public_path__ + "static/property-thumbnail-7d466bc4beb5d372a22a336605376e9e.png";